"use client";
import React, { useState } from "react";
import IMAGES from "@/data/assetData";
import Link from "next/link";
import Image from "next/image";

export default function SitemapAccordion({ categorizedData }) {
  const [showList, setShowList] = useState(null);

  const handleDisplayList = (name) => {
    setShowList((prev) => (prev === name ? null : name));
  };

  // `/data/sitemap` currently returns only type 4 (bike city) and type 9 (car
  // city) — there are no type 12 rows, so longTermRentals is always empty and
  // rendering it printed a dead "No data available" column. Drop empty
  // categories instead; the column reappears on its own if the API starts
  // returning them.
  const categories = [
    { key: "bikeRentals", title: "Bike Rentals", label: "Bike Rentals in" },
    { key: "carRentals", title: "Car Rentals", label: "Car Rentals in" },
    { key: "longTermRentals", title: "Long Term Rentals", label: "Long Term Rentals in" },
  ].filter(({ key }) => categorizedData[key]?.length > 0);

  return (
    <div className="md:grid grid-cols-12 gap-6">
      {categories.map(({ key, title, label }) => (
        <div key={key} className="col-span-3">
          <h2 className="font-medium md:mb-4">{title}</h2>
          <ul>
            {categorizedData[key]?.length > 0 ? (
              categorizedData[key].map((item, index) => {
                const linkUrl = `${item.url}/`;
                return (
                  <li key={index} className="py-2">
                    <div className="flex items-center">
                      <Link className="text-base text-slate-600" href={linkUrl}>
                        {`${label} ${item.name}`}
                      </Link>
                      {item.urls?.length > 0 && (
                        <Image
                          width={12}
                          height={12}
                          className="ml-3 cursor-pointer"
                          src={showList === item.name ? IMAGES.arrowUp : IMAGES.arrowDown}
                          alt="Toggle dropdown"
                          onClick={() => handleDisplayList(item.name)}
                        />
                      )}
                    </div>
                    {/* Locality URLs are always rendered in the HTML (not gated by `showList`)
                        so Googlebot can discover them. CSS hides them visually until the user
                        expands — but they remain in the DOM and crawlable. Gating them behind
                        a click previously caused every locality page to be near-orphaned. */}
                    {item.urls?.length > 0 && (
                      <ul
                        className={`ml-4 mt-1 ${showList === item.name ? "" : "hidden"}`}
                        aria-hidden={showList === item.name ? undefined : "true"}
                      >
                        {item.urls.map((subitem, subIndex) => {
                          const subLinkUrl = `${subitem.url}/`;
                          return (
                            <li key={subIndex} className="py-2">
                              <div className="flex items-center">
                                <Link className="text-base text-slate-600" href={subLinkUrl}>
                                  {`${label} ${subitem.name}`}
                                </Link>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </li>
                );
              })
            ) : (
              <p>No data available for {title}.</p>
            )}
          </ul>
        </div>
      ))}
    </div>
  );
}

